import PropTypes from "prop-types";
import { NavLink, useLocation } from "react-router-dom";
import "./TopTabBar.scss";

const TopTabBar = ({ tabs, actions }) => {
  const location = useLocation();

  return (
    <div className="top-tab-bar">
      <nav className="top-tab-bar__nav">
        {tabs.map(tab => {
          const Icon = tab.icon;
          const isActive = tab.exact ? location.pathname === tab.to : location.pathname.startsWith(tab.to);

          return (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={`top-tab-bar__tab ${isActive ? "top-tab-bar__tab--active" : ""}`}
            >
              {Icon && <Icon size={16} className="top-tab-bar__tab-icon" />}
              <span className="top-tab-bar__tab-label">{tab.label}</span>
            </NavLink>
          );
        })}
      </nav>
      {actions && <div className="top-tab-bar__actions">{actions}</div>}
    </div>
  );
};

TopTabBar.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      to: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.elementType,
      exact: PropTypes.bool,
    })
  ).isRequired,
  actions: PropTypes.node,
};

export default TopTabBar;
